import { getAudiences } from '../services';
export const fetchAudiences = (term = '') => {
    return getAudiences(term)
        .then(response => formatResponse(response.data))
        .catch(() => ({
        success: false,
        data: [],
    }));
};
const formatResponse = (response) => {
    const MARKETING_CLOUD_DEFAULT_AUDIENCE_ID = 0;
    return {
        success: response.success,
        data: response.data
            .map(audience => ({
            id: audience.id,
            name: audience.name,
            count: audience.count,
        }))
            .filter(audience => audience.id !== MARKETING_CLOUD_DEFAULT_AUDIENCE_ID),
    };
};
